<template lang="pug">
a.btn.btn-icon.download(target="_blank" v-bind:href="downloadUrl") 
  i.fa.fa-download(style="padding-right: 5px;")
  | {{btnTitle}}
</template>
<script>
import Store from '../store/store.js'
import querystring from 'query-string'
export default {
  props: {
    reportApi: String,
    pagetitle: String,
    subtitle: String,
    params: Object,
    btnTitle: {
      type: String,
      default: '下载报表'
    }
  },
  computed: {
    downloadUrl() {
      let param = JSON.parse(JSON.stringify(this.params))
      param.isdwn = 1
      if(this.pagetitle){
        //设置默认domain
        //this.$store.commit('SET_CURRENT_DOMAIN', {domain: '38rand.com'})
        param.fname = this.$store.state.currentDomain.domain + '_' + this.pagetitle
        if(this.subtitle){
          param.fname += '_' + this.subtitle
        }
        if(_.has(this.params, 'start') && this.params.start && this.params.end){
          param.fname += '_' + this.params.start + '-' + this.params.end
        }
      }else{
        console.err('没有设置页面标题！')
      }
      let conjunc = this.reportApi.indexOf('?') >= 0 ? '&' : '?'
      return this.reportApi + conjunc + querystring.stringify(param)
    }
  }
}
</script>



// WEBPACK FOOTER //
// downloadBtn.vue?e69683c4